


















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ModalEdit from "@/components/ModalEdit.vue";
import { CMProfile } from "@/models/cm-profile.model";
import { CMPRofileApi, _retrieveToken } from "@/services/api.service";
import { validationMixin } from "vuelidate";
import {
    required,
    email,
    minLength,
    maxLength
} from "vuelidate/lib/validators";

@Component({
    components: {
        ModalEdit
    },
    mixins: [validationMixin]
})
export default class ProfileCommunities extends Vue {
    public showEditDialog: boolean = false;
    public communitiesFilled: boolean = false;
    public titleModalEdit: string = "";
    public communities: string = "";
    public CMCommunities: any = [];
    public saving: boolean = false;

    public get profile() {
        return this.$store.getters.profile;
    }

    public async mounted() {
        this.communitiesFilled = this.profile.communities.length > 0;
        this.CMCommunities = await this.$communityApi.getCommunities(
            1,
            20,
            "joined"
        );
    }

    public handleModalClose() {
        this.showEditDialog = false;
    }

    public openModalEdit(event, id?: string) {
        this.communities = this.profile.communities.join(", ");
        this.showEditDialog = true;
    }

    public async updateCommunities() {
        this.saving = true;
        try {
            this.profile.communities = await CMPRofileApi.updateCommunities(
                this.communities.split(",").map(s => s.trim())
            );
            this.communitiesFilled = this.profile.communities.length > 0;
            this.$store.commit("updateProfile", this.profile);
            this.showEditDialog = false;
        } catch (e) {
            console.error(e);
        } finally {
            this.saving = false;
        }
    }
}
